import { getFormattedAddressData } from './getFormattedAddressData'

import { AddressData, CurrentAddressData } from '@/src/interfaces'

const MAPBOX_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN

export const getFullAddressFromLatLong = async (
  latitude: number,
  longitude: number
): Promise<CurrentAddressData> => {
  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${MAPBOX_TOKEN}`
    )

    if (!response.ok) {
      throw new Error(`Failed to fetch address: ${response.statusText}`)
    }

    const data: AddressData = await response.json()
    if (data.features.length > 0) {
      return getFormattedAddressData(data.features[0])
    } else {
      throw new Error('No address found')
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'An unknown error occurred'
    throw new Error(`Fetch failed: ${errorMessage}`)
  }
}
